import { GET_EVIDENCE_LIST } from "../../modules/constants";

export function getEvidenceList(value) {
  return {
    type: GET_EVIDENCE_LIST,
    payload: value,
  };
}